import * as actions from "../actions";
import _ from "underscore";
import update from "immutability-helper";

export const initialState = {
  accountingEurope: {
    fetching: false,
    fetched: false,
    exporting: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: undefined,
    rawData: undefined,
  },

  accountingSweden: {
    fetching: false,
    fetched: false,
    exporting: false,
    error: null,
    table: {
      currentFilter: null,
      pagination: { page: 1, take: 10 },
    },
    data: undefined,
    rawData: undefined,
  },
  solvenLoans: {
    data: [],
    fetching: false,
  },
};

export function accountingSubreducer(state, action) {
  switch (action.type) {
    // GET ACCOUNTING RESULTS
    case actions.ACCOUNTING_LIST_EUROPE_GET_REQUEST:
      return Object.assign({}, state, {
        accountingEurope: Object.assign({}, state.accountingEurope, {
          fetching: true,
          error: null,
          data: null,
        }),
      });
    case actions.ACCOUNTING_LIST_SWEDEN_GET_REQUEST:
      return Object.assign({}, state, {
        accountingSweden: Object.assign({}, state.accountingSweden, {
          fetching: true,
          error: null,
          data: null,
        }),
      });
    case actions.ACCOUNTING_LIST_EUROPE_GET_SUCCESS:
      return Object.assign({}, state, {
        accountingEurope: Object.assign({}, state.accountingEurope, {
          fetching: false,
          fetched: true,
          data: transformVouchers(action.response),
          rawData: action.response,
        }),
      });
    case actions.ACCOUNTING_LIST_SWEDEN_GET_SUCCESS:
      return Object.assign({}, state, {
        accountingSweden: Object.assign({}, state.accountingSweden, {
          fetching: false,
          fetched: true,
          data: transformVouchers(action.response),
          rawData: action.response,
        }),
      });
    case actions.ACCOUNTING_LIST_EUROPE_GET_ERROR:
      return Object.assign({}, state, {
        accountingEurope: Object.assign({}, state.accountingEurope, {
          fetching: false,
          error: action.error,
        }),
      });
    case actions.ACCOUNTING_LIST_SWEDEN_GET_ERROR:
      return Object.assign({}, state, {
        accountingSweden: Object.assign({}, state.accountingSweden, {
          fetching: false,
          error: action.error,
        }),
      });
    case actions.ACCOUNTING_LIST_EUROPE_CHANGE_PAGE:
      return Object.assign({}, state, {
        accountingEurope: Object.assign({}, state.accountingEurope, {
          table: Object.assign({}, state.accountingEurope.table, {
            pagination: Object.assign(
              {},
              state.accountingEurope.table.pagination,
              {
                page: action.page,
              },
            ),
          }),
        }),
      });
    case actions.ACCOUNTING_LIST_SWEDEN_CHANGE_PAGE:
      return Object.assign({}, state, {
        accountingSweden: Object.assign({}, state.accountingSweden, {
          table: Object.assign({}, state.accountingSweden.table, {
            pagination: Object.assign(
              {},
              state.accountingSweden.table.pagination,
              {
                page: action.page,
              },
            ),
          }),
        }),
      });
    case actions.ACCOUNTING_LIST_EUROPE_CHANGE_FILTER:
      return Object.assign({}, state, {
        accountingEurope: Object.assign({}, state.accountingEurope, {
          table: Object.assign({}, state.accountingEurope.table, {
            currentFilter: Object.assign(
              {},
              state.accountingEurope.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    case actions.ACCOUNTING_LIST_SWEDEN_CHANGE_FILTER:
      return Object.assign({}, state, {
        accountingEurope: Object.assign({}, state.accountingEurope, {
          table: Object.assign({}, state.accounting.table, {
            currentFilter: Object.assign(
              {},
              state.accounting.table.currentFilter,
              {
                ...action.filter,
              },
            ),
          }),
        }),
      });
    case actions.ACCOUNTING_EXPORT_EUROPE_REQUEST:
      return Object.assign({}, state, {
        accountingEurope: Object.assign({}, state.accoutingEurope, {
          exporting: true,
        }),
      });
    case actions.ACCOUNTING_EXPORT_SWEDEN_REQUEST:
      return Object.assign({}, state, {
        accountingSweden: Object.assign({}, state.accoutingSweden, {
          exporting: true,
        }),
      });
    case actions.ACCOUNTING_EXPORT_EUROPE_SUCCESS:
      return Object.assign({}, state, {
        accountingEurope: Object.assign({}, state.accoutingEurope, {
          exporting: false,
        }),
      });
    case actions.ACCOUNTING_EXPORT_SWEDEN_SUCCESS:
      return Object.assign({}, state, {
        accountingSweden: Object.assign({}, state.accountingSweden, {
          exporting: false,
        }),
      });
    case actions.ACCOUNTING_EXPORT_EUROPE_ERROR:
      return Object.assign({}, state, {
        accountingEurope: Object.assign({}, state.accountingEurope, {
          exporting: false,
          error: action.error,
        }),
      });
    case actions.ACCOUNTING_EXPORT_SWEDEN_ERROR:
      return Object.assign({}, state, {
        accountingSweden: Object.assign({}, state.accountingSweden, {
          exporting: false,
          error: action.error,
        }),
      });
    case actions.GET_CREDIT_BY_GUID_REQUEST:
      return update(state, {
        solvenLoans: { fetching: { $set: true } },
      });
    case actions.GET_CREDIT_BY_GUID_SUCCESS: {
      const solvenLoanExists = _.find(state.solvenLoans.data, (item) => {
        return item.Id === action.response.Id;
      });

      const roundedRemainingAmount =
        Math.round(action.response.RemainingAmount * 10000) / 10000;
      if (roundedRemainingAmount > 0 && !solvenLoanExists)
        return update(state, {
          solvenLoans: { data: { $push: [action.response] } },
        });
      return state;
    }
    case actions.CHANGE_SOLVEN_PAID_PARTS:
      if (state.solvenLoans.data.length > 0) {
        const _principal = action.principal;
        const _interest = action.interest;
        const _fees = action.fees;

        const totalAmountOnLoans = _.reduce(
          state.solvenLoans.data,
          (memo, item) => {
            return memo + item.Amount;
          },
          0,
        );

        const interestFactor = _.reduce(
          state.solvenLoans.data,
          (memo, item) => {
            return memo + item.Amount * item.InterestAsFraction;
          },
          0,
        );

        return update(state, {
          solvenLoans: {
            data: {
              $apply: (a) =>
                a.map((item) => {
                  const percentage = item.Amount / totalAmountOnLoans;
                  return {
                    ...item,
                    Interest:
                      Math.round(
                        ((_interest * item.Amount * item.InterestAsFraction) /
                          interestFactor) *
                          10000,
                      ) / 10000,
                    Principal:
                      Math.round(_principal * percentage * 10000) / 10000,
                    Fees: Math.round(_fees * percentage * 10000) / 10000,
                  };
                }),
            },
          },
        });
      } else return state;
    default:
      return state;
  }
}

const transformVouchers = (vouchers) => {
  var data = [];
  _.each(vouchers, (voucher) => {
    _.each(voucher.VoucherRows, (voucherRow) => {
      data.push({
        VoucherSeries: voucher.VoucherSeries,
        EventGlobalSeqNr: voucher.EventGlobalSeqNr,
        TransactionDate: voucher.TransactionDate,
        Comments: voucher.Comments,
        Account: voucherRow.Account,
        CostCenter: voucherRow.CostCenter,
        Credit: voucherRow.Credit.Amount,
        Debit: voucherRow.Debit.Amount,
        Description: voucherRow.Description,
        Project: voucherRow.Project,
        TransactionInformation: voucherRow.TransactionInformation,
      });
    });
  });

  data = data.sort((a, b) => {
    return new Date(a.TransactionDate) - new Date(b.TransactionDate);
  });

  return data;
};
